import { RecommendedProductsSection } from './RecommendedProductsSection';

export { Root } from './RecommendedProductsSection';
export default RecommendedProductsSection;
